import { render, staticRenderFns } from "./customzj.vue?vue&type=template&id=f1462366&scoped=true&"
import script from "./customzj.vue?vue&type=script&lang=js&"
export * from "./customzj.vue?vue&type=script&lang=js&"
import style0 from "./customzj.vue?vue&type=style&index=0&id=f1462366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1462366",
  null
  
)

export default component.exports